module.exports = "/packs/as_img03-1a77fd5cdb336dc068c4c0a067c5cb29.png";